export default {
  name: 'marking--requestType',
};